import swal from "sweetalert"
import TaskCode from './Enums/TaskCode'
import EventBus from '../EventBus'
import { SubtaskMixin } from './SubtaskMixin'
import { Mixin } from './Mixins/mixin'
import { DateMixin } from "./Mixins/dateMixin"
import { ZipCodeMixin } from "./helpers/zipCodeMixin.js"
import TaskType from "./Enums/TaskType"
import AppointmentType from "./Enums/AppointmentType"
import TaskState from "./Enums/TaskState"
import TicketState from "./Enums/TicketState"
import ProjectType from "./Enums/ProjectType"
import CachedSettings from "@/modules/Settings/settingsClass"
import { ProjectSettingsMixin } from '@/modules/ProjectSettings/projectSettingsMixin.js'
import { mapGetters } from 'vuex'
import { db } from '@/firebase'

export const Bookingmixin = {

    mixins: [
        SubtaskMixin, 
        Mixin, 
        DateMixin, 
        ProjectSettingsMixin, 
        ZipCodeMixin
    ],

    enums: {
        TaskCode
    },

    data() {
        return {
            hasCheckedAppointments: false,
            loadAttempt: 0,

            rawTasks: new Map(),

            closedTasks: [], // TODO. Update to map instead of array
            tasks: new Map(),

            installations: [], // TODO: Update to map instead of array
            allUpdates: [],

            failedInstallationMissingCoordinates: [],

            stashedTechnicals: {
                hubs: {},
                uubs: {},
            },

            tasksWithoutInstallationLabels: [],

            settingsBD: new CachedSettings(),

            loadProjectTasks: true,
            loadTickets: false,
            hasActiveProject: false,
            getBaseBookingDataComplete: false,

        }
    },

    computed: {
        ...mapGetters({
            project: 'activeProject',
        }),
    },

    methods: {

        onSettingUpdate(key) {
            switch (key) {
                case 'projectPreferences': console.log(key,"This setting does not require an update method") 
                    break
                case 'showMap': if(this.settingsBD.get("showMap")){
                    // this.initializeMaps()
                    // location.reload() //When map is enabled, a reload is required
                    this.bookFormatBookingData(true)
                }
                    break
                case 'mapUseAutoZoom': console.log(key,"This setting does not require an update method")
                    break
                case 'bookedSelectedOptions':
                    for (let i in this.bookedSortingOptions)
                    {
                        let index = this.settingsBD.get("bookedSelectedOptions").findIndex(p => {
                            return p.value == this.bookedSortingOptions[i].value})
                        this.bookedSortingOptions[i].rank = this.settingsBD.get("bookedSelectedOptions")[index].rank
                    } 
                    break
                case 'bookSortAscending': console.log(key,"This setting does not require an update method") 
                    break
                case 'sortUnbookedPTBy': if (this.settingsBD.get("sortUnbookedPTBy") == "productDeliveryDate") this.getAllProducts()
                    break
                case 'sortInstsBy': if (this.settingsBD.get("sortInstsBy") == "productDeliveryDate") this.getAllProducts()
                    break
                case 'showUnbookedCard': if (this.settingsBD.get('showUnbookedCard')){
                        this.bookGetBaseBookingData(
                            this.settingsBD.get('showPendingTasks'),
                            this.settingsBD.get('showOnHoldTasks'),
                            this.settingsBD.get('showResolved')
                        )
                    }
                    break
                case 'showPendingTasks': if (this.settingsBD.get('showPendingTasks')){
                        this.bookGetBaseBookingData(
                            this.settingsBD.get('showPendingTasks'),
                            this.settingsBD.get('showOnHoldTasks'),
                            this.settingsBD.get('showResolved')
                        );
                    }
                    this.regenerateMapMarkers()
                    break
                case 'showOnHoldTasks': if (this.settingsBD.get('showOnHoldTasks')){
                        this.bookGetBaseBookingData(
                            this.settingsBD.get('showPendingTasks'),
                            this.settingsBD.get('showOnHoldTasks'),
                            this.settingsBD.get('showResolved')
                        );
                    }
                    this.regenerateMapMarkers()
                    break
                case 'showResolved': if (this.settingsBD.get('showResolved')){
                        this.bookGetBaseBookingData(
                            this.settingsBD.get('showPendingTasks'),
                            this.settingsBD.get('showOnHoldTasks'),
                            this.settingsBD.get('showResolved')
                        );
                    }
                    break
                case 'showClosed': this.showHideClosedTasks(this.project.AreaCodes)
                    break
                case 'showCloseCPETaskShortcut': console.log(key,"This setting does not require an update method") 
                    break
                case 'showTaskTypeIcon': console.log(key,"This setting does not require an update method")
                    break
                case 'showSubtaskStatus': console.log(key,"This setting does not require an update method")
                    break
                case 'showCounters': console.log(key,"This setting does not require an update method")
                    break
                case 'showWeekNums': console.log(key,"This setting does not require an update method")
                    break
                case 'highlightOwnAppointments': console.log(key,"This setting does not require an update method")
                    break
                case 'showNavigationIcon': console.log(key,"This setting does not require an update method")
                    break
                case 'showCallInAdvanceIcon': console.log(key,"This setting does not require an update method")
                    break
                case 'showApptTypeInspection': this.regenerateMapMarkers()
                    break
                case 'showApptTypeInstallation': this.regenerateMapMarkers()
                    break
                case 'showApptTypeTechnician': this.regenerateMapMarkers()
                    break
                case 'showApptTypePatch': this.regenerateMapMarkers()
                    break
                case 'showApptTypeKS': this.regenerateMapMarkers()
                    break
                case 'showApptTypeCabinets': 
                    this.bookGetBaseBookingData(
                        this.settingsBD.get('showPendingTasks'),
                        this.settingsBD.get('showOnHoldTasks'),
                        this.settingsBD.get('showResolved')
                    );
                    break
                case 'showApptTypeTickets': this.regenerateMapMarkers()
                    break
                case 'bookedDuration': 
                    this.getAppointments('asc')
                    this.getCustomAppointments('asc')
                    break
                case 'selectedCabinetsFilter':
                    this.bookGetBaseBookingData(
                        this.settingsBD.get('showPendingTasks'),
                        this.settingsBD.get('showOnHoldTasks'),
                        this.settingsBD.get('showResolved')
                    )
                    break
                default: console.log("An update method have not been implemented for this setting",key)
            }
        }, 

        /**
         * Fetches base data for project tasks from Pilotbi.
         * @param {Array} areaCodes
         */
        async bookGetBaseBookingData(
            includePending = false, 
            includeOnHold = true,
            includeResolved = false, 
        ) 
        {
            EventBus.$emit('function-activity', {functionName: 'Bookingmixin_bookGetBaseBookingData', isActive: true})
            EventBus.$emit('loading-timelines', true)
            this.getBaseBookingDataComplete = false
            this.clearTasksInRawTasks()

            let whitelist = {
                includesProjectTasks: false,
                includesTroubleTickets: false,
            };

            for (let i in this.appointments) {
                let appointment = this.appointments[i];
                whitelist[`${appointment.InstallationLabel}`] = {taskType: appointment.AppointmentType === AppointmentType.TICKET ? 'TROUBLETICKET' : 'PROJECTTASK'};  
                if (appointment.AppointmentType === AppointmentType.TICKET) {
                    whitelist.includesTroubleTickets = true;
                } else {
                    whitelist.includesProjectTasks = true;
                }
            }
            if (this.project?.whitelist) {
                for (let key of Object.keys(this.project.whitelist)) {
                    console.log("entry from project whitelist", key, this.project.whitelist[key])
                    whitelist[`${key}`] = this.project.whitelist[key]
                }
            }

            let apiData = await this.dataGetAllTasks({
                projectId: this.settingsBD.get('showUnbookedCard') ? this.project.id : null,
                taskFamily: this.settingsBD.get('showApptTypeCabinets') ? 'all' : 'installations',
                flags: {
                    includePending: includePending,
                    includeOnHold: includeOnHold,
                    includeResolved: includeResolved,
                },
                blacklist: null, // TODO: Include project blacklist
                whitelist: whitelist, // TODO: Include project whitelist
                cabinetWhitelist: this.settingsBD.get('selectedCabinetsFilter') || [], // TODO: Take from user settings
            });

            console.log("API data",apiData)

            for (let task of apiData) {
                this.setOrUpdateTaskInRawTasks(task)
            }

            await this.bookFormatBookingData(this.settingsBD.get("showMap"))
            await this.bookAppointmentCheckTasks()

            for (let i in this.installations){
                let taskCodes = []
                for (let j in this.installations[i].tasks){
                    taskCodes.push(TaskCode.formatTaskCode(this.installations[i].tasks[j].code))
                }
                if (taskCodes.includes(TaskCode.TICKET) && taskCodes.length > 1){
                    console.log("This installations includes tickets",this.installations[i])
                }
            }

            this.getBaseBookingDataComplete = true
            console.log("Get base booking data complete")

            EventBus.$emit('function-activity', {functionName: 'Bookingmixin_bookGetBaseBookingData', isActive: false})
            return
        },

        clearTasksInRawTasks(){
            this.rawTasks = new Map()
        },

        setOrUpdateTaskInRawTasks(task, isFullTask = false){
            if ((task?.isFullTask != false && task?.isFullTask != true) || isFullTask == true){
                task.isFullTask = isFullTask
            }
            
            if (!this.rawTasks.has(task.id)){ // Set task in rawTasks
                this.rawTasks.set(task.id, task)
            } else { // Update task in rawTasks
                let taskInRawTasks = this.rawTasks.get(task.id)

                // Preserve FiberLAN specific data
                task.BillingProject = taskInRawTasks?.BillingProject || 'unknown'
                task.BillingProjectSetManually = taskInRawTasks?.BillingProjectSetManually || false
                task.Coordinates = taskInRawTasks?.Coordinates || null
                task.LinkedProjects = taskInRawTasks?.LinkedProjects || []
                task.InstallationLabel = taskInRawTasks?.InstallationLabel || ''
                task.SourceOrigin = taskInRawTasks?.SourceOrigin || ''
                task.TaskFirstSeen = taskInRawTasks?.TaskFirstSeen || ''
                if (taskInRawTasks?.BillingProjectOptions) task.BillingProjectOptions = taskInRawTasks.BillingProjectOptions

                if (!task.project?.type?.value) task.project = taskInRawTasks.project //Preserve project data (not included in full task)
                if (!task.products || !task.products.length) task.products = taskInRawTasks.products //Preserve products array
                if (!task.productDeliveryDate) task.productDeliveryDate = taskInRawTasks.productDeliveryDate //Preserve productDeliveryDate
                this.rawTasks.set(task.id, task)
            }

            // TODO: Update task state on appointment and or maybe cached tasks 
            if (this.getBaseBookingDataComplete){
                this.allTasksComplete(task.id)
            }
        },

        updateTaskStateInRawTasks(id, newState){
            let rawTask = this.rawTasks.get(id)
            rawTask.state = newState
            this.rawTasks.set(id, rawTask)

            // TODO: Update task state on appointment if any
            if (this.getBaseBookingDataComplete){
                this.allTasksComplete(id)
            }
        },

        async getCabinetFilterOptions(){
            EventBus.$emit('function-activity', {functionName: 'Bookingmixin_getCabinetFilterOptions', isActive: true})

            try {
                let cabinetOptions = []
    
                let pilotBiCacheDoc = await db.collection('cacheData').doc('pilotBiTasksAndTickets').get();
                pilotBiCacheDoc = pilotBiCacheDoc.data();
    
                if (pilotBiCacheDoc?.projectMeta && pilotBiCacheDoc.projectMeta[this.project.id]) {
                    let projectMeta = pilotBiCacheDoc.projectMeta[this.project.id];
                    cabinetOptions = (projectMeta.cabinets || []).map(cabinet => ({
                        value: cabinet,
                        text: cabinet
                    })).sort((a, b) => a.value.localeCompare(b.value));
                    this.settingsBD.setOptions('selectedCabinetsFilter',cabinetOptions);

                    // Make sure current selected options are still valid
                    let currentSelectedOptions = this.settingsBD.get('selectedCabinetsFilter') || [];
                    let validSelectedOptions = currentSelectedOptions.filter(option => cabinetOptions.some(cabinet => cabinet.value === option));
                    if (validSelectedOptions.length !== currentSelectedOptions.length) {
                        this.settingsBD.set('selectedCabinetsFilter', validSelectedOptions);
                    }
                }
    
                EventBus.$emit('function-activity', {functionName: 'Bookingmixin_getCabinetFilterOptions', isActive: false})
                return true
            } catch (error) {
                console.error("Error fetching cabinet filter options:", error);
                EventBus.$emit('function-activity', {functionName: 'Bookingmixin_getCabinetFilterOptions', isActive: false})
            }
        },

        async allTasksComplete(id, isAppointmentId = false){
            EventBus.$emit('function-activity', {functionName: 'Bookingmixin_allTasksComplete', isActive: true})
            // Default is task id
            
            let appointment = null
            if (!isAppointmentId){
                // Find associate appointment if any
                if (this.appointments){
                    for (let i in this.appointments){
                        for (let j in this.appointments[i].ProjectTasks){
                            if (this.appointments[i].ProjectTasks[j].Id === id){
                                appointment = this.cloneJson(this.appointments[i])
                                appointment.id = this.appointments[i].id
                                break
                            }
                        }
                    }
                    if (!appointment){
                        // console.log("No appointment found")
                        EventBus.$emit('function-activity', {functionName: 'Bookingmixin_allTasksComplete', isActive: false})
                        return false
                    }
                } else {
                    EventBus.$emit('function-activity', {functionName: 'Bookingmixin_allTasksComplete', isActive: false})
                    return false
                }
            } else {
                // Find appointment based on id
                if (this.appointments){
                    for (let i in this.appointments){
                        if (this.appointments[i].id === id){
                            appointment = this.cloneJson(this.appointments[i])
                            appointment.id = this.appointments[i].id
                            break
                        }
                    }
                    if (!appointment){
                        // console.log("Error appointment not found")
                        EventBus.$emit('function-activity', {functionName: 'Bookingmixin_allTasksComplete', isActive: false})
                        return false
                    }
                } else {
                    EventBus.$emit('function-activity', {functionName: 'Bookingmixin_allTasksComplete', isActive: false})
                    return false
                }
            }

            let allTasksComplete = true
            for (let i in appointment.ProjectTasks){
                let task = this.rawTasks.get(appointment.ProjectTasks[i].Id)
                let state = task?.state?.value
                let code = task?.code
                if (state && code){
                    if (TaskCode.taskHasCode(task, TaskCode.TICKET)){
                        let options = [TicketState.CLOSED, TicketState.RESOLVED]
                        if (!options.includes(state)){
                            allTasksComplete = false
                            break
                        }
                    } else {
                        if (state != TaskState.CLOSED_COMPLETE){
                            allTasksComplete = false
                            break
                        }
                    }  
                } else {
                    allTasksComplete = false
                }
            }

            let currentAllTasksComplete = appointment?.AllTasksComplete
            if (currentAllTasksComplete != allTasksComplete){
                // console.log("All tasks complete state does not match with appointment")
                // console.log("Appointment id",appointment.id)
                await this.dataAddOrUpdateAppointment(appointment.id, {AllTasksComplete: allTasksComplete})
            }
            EventBus.$emit('function-activity', {functionName: 'Bookingmixin_allTasksComplete', isActive: false})
            return true
        },

        async bookGetCabinetTasks(cabinetArray, includePending, includeOnHold) {
            EventBus.$emit('function-activity', {functionName: 'Bookingmixin_bookGetCabinetTasks', isActive: true})
            EventBus.$emit('loading-timelines', true)

            let disallowedStates = []
            if (!includePending) {
                disallowedStates.push(TaskState.PENDING)
            }
            if (!includeOnHold) {
                disallowedStates.push(TaskState.ON_HOLD)
            }
            
            // CONSTRUCT QUERY STRING
            let queryString = this.dataConstructQueryString(null, [ProjectType.CABINET], null, disallowedStates, null, null, false, cabinetArray)
            console.log(queryString)
            // let one = 1
            // if (one == 1) return //Ignores the rest of the function, while debugging queryString

            let apiData = await this.dataGetTasksV2(TaskType.PROJECTTASK, null, null, queryString)
            
            /*
             * Replaces each task and adds new tasks, instead of replacing the whole dataset.
             * Because some tasks may derive from `bookAppointmentCheckTasks`
             */
            for (let i in apiData.projectTasks) {
                this.setOrUpdateTaskInRawTasks(apiData.projectTasks[i])
            }

            await this.bookAppointmentCheckTasks()
            EventBus.$emit('function-activity', {functionName: 'Bookingmixin_bookGetCabinetTasks', isActive: false})
        },

        /**
         * Formats the `rawTasks` data.
         * @param {Boolean} withLocationData 
         */
        async bookFormatBookingData(withLocationData = true) {
            EventBus.$emit('function-activity', {functionName: 'Bookingmixin_bookFormatBookingData', isActive: true})
            // console.log('formatting booking data')
            // const rawTaskArray = this.rawTasks.sort((a,b) => { //Format based on rawTasks, sorted by task number to ensure chonology
            //     return a.number > b.number ? 1 : -1
            // })
            const installationModel = JSON.stringify({
                label: '',
                tasks: [], // Indexed array, not key-value pair
                associatedTasks: [], // Cabinet tasks associated with the installation
                appointments: {}, //Object with document id's as properties
                installationFirstSeen: 'N/A',
            })

            // Get coordinates if withLocationData flag is on.
            let coordinates;
            let tasksWithoutCoordinates = []
            try {
                if (withLocationData) {
                    if (!this.$route.params.projectIdentifier) {
                        throw new Error(`Route params did not include property 'projectIdentifier': ${JSON.stringify(this.$route.params)}`)
                    }
                    // console.log('Getting coordinates from firestore')
                    coordinates = await this.dataGetAllProjectCoordinates(this.$route.params.projectIdentifier)
                }
            } catch (error) {
                console.error(`Error getting coordinates from Firestore: ${error}`)
            }

            // Loops through and format rawTaskArray into dataMap with format from `installationModel`
            let dataMap = new Map()
            for await (let taskKey of this.rawTasks.keys()) {
                let task = this.rawTasks.get(taskKey)
                var label = this.getConfigurationLabel(task);
                if (!label) { // Try and get via cache
                    console.warn(`Task ${task.number} has no configurationItem label. Trying to get from cache...`)
                    label = task?.InstallationLabel || null;
                }

                if (!label) { //Handle missing installation number, by using task ID
                    console.error(`task '${task.number}' has no configurationItem label`)
                    if (!this.tasksWithoutInstallationLabels.includes(task.number)){
                        this.tasksWithoutInstallationLabels.push(task.number)
                        swal('Opgave uden installationsnummer', `Der blev fundet en eller flere opgaver i PilotBI der tilsyneladende ikke er tilknyttet nogen installation:\n${this.tasksWithoutInstallationLabels.join('\n')}`, 'warning')
                    }
                    label = task.number ? task.number : task.id
                }
                let model;
                if (dataMap.has(label)) { //If the data map already contains the same installation
                    model = dataMap.get(label) //Add this task to that installation
                } else { //Otherwise make a new installation for the task
                    model = JSON.parse(installationModel)
                    model.label = label
                    model.instId = this.getConfiguration(task)?.value || this.getConfiguration(task)?.label || this.getConfiguration(task)?.number
                }

                if (!Array.isArray(model.tasks)) {
                    model.tasks = []
                }

                //If any task has referenceId, share that with the other tasks
                if (task.referenceId && !model.tasks[0]?.referenceId){ //If current task has a referenceId, but the first task on the model does not
                    for (let i in model.tasks) { //Loop through all tasks on the model
                        model.tasks[i].referenceId = task.referenceId //Add referenceId to each task
                    }
                } else if (!task.referenceId && model.tasks[0]?.referenceId) { //If current task does not have a referenceId, but the first task on the model does
                    task.referenceId = model.tasks[0].referenceId //Add the referenceId from the first task to the model
                }

                //If any task has project (used for project.type.value), share that with tasks that doesn't
                if (task.project && !model.tasks[0]?.project){ //If current task has a project, but the first task on the model does not
                    for (let i in model.tasks) { //Loop through all tasks on the model
                        if (!model.tasks[i].project) {
                            model.tasks[i].project = task.project //Add project to each task that doesn't have it
                        }
                    }
                } else if (!task.project && model.tasks[0]?.project) { //If current task does not have a project, but the first task on the model does
                    task.project = model.tasks[0].project //Add the project from the first task to the model
                }

                // Check first seen timestamp on task
                if (task?.TaskFirstSeen && model.installationFirstSeen === 'N/A') {
                    model.installationFirstSeen = task.TaskFirstSeen
                } else if (task?.TaskFirstSeen && new Date(task?.TaskFirstSeen) < new Date(model.installationFirstSeen)) {
                    model.installationFirstSeen = task.TaskFirstSeen
                }

                model.tasks.push(task) // Push current task to the model
                dataMap.set(label, model)

                if ((model.tasks[0] || task) && (this.getConfigurationInstallation(model)?.cabinet?.name || this.getConfiguration(task)?.cabinet?.name)) {
                    let id = this.getConfigurationInstallation(model)?.cabinet?.name || this.getConfiguration(task)?.cabinet?.name
                    let hubId = id.replaceAll(' ', '')
                    hubId = hubId.substring(0, hubId.indexOf('-') - 1)
                    let technicals = []
                    if (this.stashedTechnicals.hubs[hubId]) {
                        technicals = technicals.concat(this.stashedTechnicals.hubs[hubId])
                    }
                    if (this.stashedTechnicals.uubs[id]) {
                        technicals = technicals.concat(this.stashedTechnicals.uubs[id])
                    }
                    model.technicals = technicals // Add technicals (hub and uub) to the model
                    dataMap.set(label, model)
                }

                /* 
                 * If `withLocationData` is on, then attach coords if exists or fail the task 
                 * by pushing the task to `tasksWithoutCoordinates`
                 */
                if (withLocationData && typeof(coordinates) != 'undefined') {
                    if (!this.getConfigurationInstallation(model)?.address?.road) continue
                    if (!coordinates.has(label)) {
                        // console.log(`Installation ${label} has no coordinates in store`)
                        tasksWithoutCoordinates.push(task)
                        continue
                    }
                    model.coordinates = coordinates.get(label) //Add coordinates to the model
                    dataMap.set(label, model)
                }
            }

            if (this.appointments) {
                for (let appointment of this.appointments) {
                    const appointmentId = appointment.id
                    if (!dataMap.get(appointment.InstallationLabel)) {
                        if (!appointment?.AllTasksComplete){
                            console.error(`No installation for appointment '${appointmentId}' with inst#${appointment.InstallationLabel}`)
                        }
                        continue;
                    }
                    if (!dataMap.get(appointment.InstallationLabel).appointments){
                        dataMap.get(appointment.InstallationLabel).appointments = {}
                    }
                    const timeWindowObj = this.readTimeWindowString(appointment.TimeWindowString)
                    dataMap.get(appointment.InstallationLabel).appointments[appointmentId] = {
                        ...appointment,
                        Date: timeWindowObj.Date,
                        Time: timeWindowObj.Time,
                    }
                }

                for (let appointment of this.appointmentsOnActiveInstallation) {
                    const appointmentId = appointment.id
                    if (!dataMap.get(appointment.InstallationLabel)) {
                        if (!appointment?.AllTasksComplete){
                            console.error(`No installation for appointment '${appointmentId}' with inst#${appointment.InstallationLabel}`)
                        }
                        continue;
                    }
                    if (!dataMap.get(appointment.InstallationLabel).appointments){
                        dataMap.get(appointment.InstallationLabel).appointments = {}
                    }
                    const timeWindowObj = this.readTimeWindowString(appointment.TimeWindowString)
                    dataMap.get(appointment.InstallationLabel).appointments[appointmentId] = {
                        ...appointment,
                        Date: timeWindowObj.Date,
                        Time: timeWindowObj.Time,
                    }
                }
            }

            // If there was any tasks without coordinates, throw exception
            if (withLocationData && tasksWithoutCoordinates.length !== 0) {
                // console.log(`Found ${tasksWithoutCoordinates.length} tasks with missing coordinates`)
                this.installationMissingCoordinates = tasksWithoutCoordinates
                if (tasksWithoutCoordinates.length > 0 && tasksWithoutCoordinates.length <= 50) {
                    try {
                        console.log('Importing coordinates...')
                        await this.startCoordinateImport()
                    }
                    catch (error) {
                        swal('Fejl', `Kunne ikke starte import at koordinater.\n${JSON.stringify(error)}`, 'error')
                    }
                } else {
                    this.showCoordinateImportModal = true
                }
            }
            
            this.tasks = dataMap
            EventBus.$emit('loading-timelines', false)

            if (withLocationData){
                this.sleep(100).then(async () => {
                    await this.regenerateMapMarkers() //TODO: Find a way to run this function less frequently
                })
            }

            if(this.settingsBD.get('sortUnbookedPTBy') == 'productDeliveryDate') {
                this.getAllProducts()
            }
            EventBus.$emit('function-activity', {functionName: 'Bookingmixin_bookFormatBookingData', isActive: false})
            return true
        },

       async migrateUnitWorkAndSubtasksForInsts(instID){
            // console.log("Migrate subtasks and unitwork to this project")
            // console.log("  Project ID", this.project.id)
            // console.log("  Installation label", instID)

            let subtasks = await this.dataGetSubtasksForInst(instID)
            let unitwork = await this.dataGetUnitWorkForInst(instID)

            for (let doc of subtasks){
                if (!doc.LinkedProjects.includes(this.project.id)){
                    doc.LinkedProjects.push(this.project.id)
                    let docID = doc.id
                    delete doc.id
                    await this.dataGenericUpdateDocument('InternalSubTasks', docID, doc)
                }
            }

            for (let doc of unitwork){
                if (!doc.LinkedProjects.includes(this.project.id)){
                    doc.LinkedProjects.push(this.project.id)
                    let docID = doc.id
                    delete doc.id
                    await this.dataGenericUpdateDocument('UnitWork', docID, doc)
                }
            }
        },

        async migrateUnitWorkAndSubtasks(){
            let shouldContinue = await swal({
                title: 'Er du sikker på at du vil migrére enhedsarbejde og interne delopgaver til dette projekt?',
                text: 'Dette er en meget krævende handling!',
                icon: 'warning',
                buttons: true,
                dangerMode: true,
            })

            if (shouldContinue){
                let i = 0
                EventBus.$emit('data-migration-started')
                for (let inst of this.installations){
                    i++
                    let progress = Math.ceil((i / this.installations.length) * 100)
                    await this.migrateUnitWorkAndSubtasksForInsts(inst.label)
                    EventBus.$emit('data-migration-progress-percentage',progress)
                }
                EventBus.$emit('data-migration-complete')
            }

        },

        /**
         * Checks if `rawTasks` contains the associated task for each appointment.
         * If not, it fetches it and pushes to `rawTasks`.
         */
        async bookAppointmentCheckTasks() {
            if (this.hasCheckedAppointments) return
            EventBus.$emit('function-activity', {functionName: 'Bookingmixin_bookAppointmentCheckTasks', isActive: true})
            const appointments = this.appointments
            let promiseArray = []
            for (let appointment of appointments) {
                for (let appTask of appointment.ProjectTasks){
                    if (appTask.Role != 'PRIMARY') continue; //Skip non-primary tasks, so we don't waste resources getting all booking tasks for booked installations
                    if (!this.rawTasks.has(appTask.Id)){
                        if (!TaskCode.taskHasCode(appTask, TaskCode.TICKET)){
                            promiseArray.push(
                                this.dataGetProjectTask({id: appTask.Id, number: appTask.Number}).then((task) => {
                                    return this.setOrUpdateTaskInRawTasks(task, true)
                                }).catch((error) => {
                                    console.error(error)
                                    swal('Fejl i aftaler', error.message, 'error')
                                })
                            )
                        } else {
                            promiseArray.push(
                                this.dataGetTroubleTicket(appTask.Id).then((task) => {
                                    return this.setOrUpdateTaskInRawTasks(task, true)
                                }).catch((error) => {
                                    console.error(error)
                                    swal('Fejl i aftaler', error.message, 'error')
                                })
                            )
                        }
                    }
                }
            }

            return Promise.allSettled(promiseArray).then(() => {
                // console.log('finished checking appointments')
                this.hasCheckedAppointments = true
                this.bookFormatBookingData(this.settingsBD.get("showMap"))
                EventBus.$emit('function-activity', {functionName: 'Bookingmixin_bookAppointmentCheckTasks', isActive: false})
            })

        },

        async updateAllTasksOnInstallation(installation) {
            EventBus.$emit('function-activity', {functionName: 'Bookingmixin_updateAllTasksOnInstallation', isActive: true})

            if (!installation.tasks) {
                console.error(`Installation ${installation.label} has no tasks`)
                EventBus.$emit('function-activity', {functionName: 'Bookingmixin_updateAllTasksOnInstallation', isActive: false})
                return
            }

            let promiseArray = [];

            await new Promise(resolve => setTimeout(resolve, 1000))

            for (let task of installation.tasks) {
                if (TaskCode.taskHasCode(task, TaskCode.TICKET)) {
                    promiseArray.push(
                        this.dataGetTroubleTicket(task.id).then((updatedTask) => {
                            this.setOrUpdateTaskInRawTasks(updatedTask, true)
                        }).catch((error) => {
                            console.error(error)
                        })
                    )
                } else {
                    promiseArray.push(
                        this.dataGetProjectTask(task).then((updatedTask) => {
                            this.setOrUpdateTaskInRawTasks(updatedTask, true)
                        }).catch((error) => {
                            console.error(error)
                        })
                    )
                }
            }

            return Promise.allSettled(promiseArray).then(() => {
                this.bookFormatBookingData(this.settingsBD.get("showMap"))
                EventBus.$emit('function-activity', {functionName: 'Bookingmixin_updateAllTasksOnInstallation', isActive: false})
            })
        },

        /**
         * Watcher for `appointments`
         */
        async onAppointmentsMutated() {
            EventBus.$emit('function-activity', {functionName: 'Bookingmixin_onAppointmentsMutated', isActive: true})
            this.hasCheckedAppointments = false
            try {
                if (this.rawTasks.length) {
                    await this.bookAppointmentCheckTasks()
                }
            } catch (error) { //Ensure loading animation stops if error is thrown
                EventBus.$emit('function-activity', {functionName: 'Bookingmixin_onAppointmentsMutated', isActive: false})
                throw error
            }
            EventBus.$emit('function-activity', {functionName: 'Bookingmixin_onAppointmentsMutated', isActive: false})
        },

        updateInstallations() {
            let installations = []
            // Formats the map to an array
            this.tasks.forEach((value) => {
                let tasks = []
                for (const [label, task] of Object.entries(value.tasks)) {
                    tasks[label] = task
                }
                value.tasks = tasks
                installations.push(value)
            })

            this.installations = installations
        },

        filterRelevantServiceOrderTasks(serviceOrder) {
            if(!serviceOrder?.project?.tasks){
                throw new Error('Needs serviceOrder to get relevant serviceOrderTasks')
            }
            let filteredServiceOrderTasks = serviceOrder.project.tasks.filter((task) => {
                // console.log(task.code)
                return TaskCode.AllArray.includes(TaskCode.formatTaskCode(task.code))
            })
            return filteredServiceOrderTasks
        },

        async bookGetLastTask(tasks, serviceOrder) {
            EventBus.$emit('function-activity', {functionName: 'Bookingmixin_bookGetLastTask', isActive: true})
            if (!serviceOrder){
                serviceOrder = tasks[0].serviceOrder
            }
            if (!serviceOrder){
                EventBus.$emit('function-activity', {functionName: 'Bookingmixin_bookGetLastTask', isActive: false})
                return this.findLastTask(tasks)
            }
            let relevantTasks = this.filterRelevantServiceOrderTasks(serviceOrder)
            if (!relevantTasks.length) {
                EventBus.$emit('function-activity', {functionName: 'Bookingmixin_bookGetLastTask', isActive: false})
                throw new Error('No relevant tasks in serviceOrder')
            }
            let lastTask = this.findLastTask(relevantTasks)
            let updatedTask = await this.dataGetProjectTask(lastTask)
            this.setOrUpdateTaskInRawTasks(updatedTask, true)
            EventBus.$emit('function-activity', {functionName: 'Bookingmixin_bookGetLastTask', isActive: false})
            return updatedTask
        },

        async startCoordinateImport() {
            // console.log('startCoordinateImport function started')
            EventBus.$emit('function-activity', {functionName: 'Bookingmixin_startCoordinateImport', isActive: true})
            this.coordinateImportStage = 1
            let startTime = new Date()
            let index = 0
            let installations = this.installationMissingCoordinates.reduce((group, ins) => {
                if (!group[index]) group[index] = []
                if (group[index].length == this.googleCoordinateLookupsPerSecond) {
                    index++
                    group[index] = []
                }
                group[index].push(ins)
                return group
            }, [])
            
            index = 0
            let results = new Map()
            let coordinatesImportIntervalLoopRef = 0 //Interval variable must be initialized before starting the interval, otherwise it is not accessible (to clear) inside the function
            coordinatesImportIntervalLoopRef = setInterval(async () => {
                if (!installations[index]) {
                    clearInterval(coordinatesImportIntervalLoopRef)
                    let stopTime = new Date()
                    let timeDiff = stopTime - startTime
                    this.onFinishedCoordinateImport(results, timeDiff)
                    console.log(`Finished coordinate import on group ${index}/${installations.length} (group size ${installations[0].length})`)
                    EventBus.$emit('function-activity', {functionName: 'Bookingmixin_startCoordinateImport', isActive: false})
                    return
                }
                for (let i in installations[index]) {
                    let ins
                    try {
                        ins = installations[index][i]
                        let result = await this.externalGetGeoCoordinatesFromAddress(this.getConfiguration(ins).address)
                        const label = this.getConfigurationLabel(ins)
                        const type = ins?.project?.type?.value  || 'TroubleTickets' //TODO: Should be more resilient to missing data, and not assume Ticket for all missing data
                        if (!label) {
                            throw new Error(`Cannot save coordinates with no label, on inst: ${JSON.stringify(ins)}`)
                        }
                        results.set(label, { 
                            ...result, 
                            areaCode: this.getConfiguration(ins)?.area?.sonWinProjectId, 
                            type,
                        })
                        this.installationMissingCoordinatesIteratorIndex++
                    }
                    catch (error) {
                        this.failedInstallationMissingCoordinates.push(ins)
                        console.error(error.message)
                    }
                }
                index++
            }, 1000)
        },

        async onFinishedCoordinateImport(results, timeDiff) {
            EventBus.$emit('function-activity', {functionName: 'Bookingmixin_onFinishedCoordinateImport', isActive: true})
            this.coordinateImportStage = 2
            this.coordinateImportTime = parseInt(timeDiff / 1000, 10)

            try {
                await this.dataSaveCoordinates(results, this.project.id)
            }
            catch (error) {
                swal('System Fejl', `Kunne ikke gemme data i systemet. Firebase fejl.\n\n${error}`, 'error')
                console.error(error)
            }

            const countSucceeded = this.installationMissingCoordinates.length - this.failedInstallationMissingCoordinates.length
            if (countSucceeded == this.installationMissingCoordinates.length) {
                // console.log(`Re-formatting booking data with ${countSucceeded} new coordinates`)
                await this.bookFormatBookingData(true)
            } else {
                console.log(`Will not re-format booking data because only ${countSucceeded}/${this.installationMissingCoordinates.length} coordinates were successfully retrieved`)
            }
            EventBus.$emit('function-activity', {functionName: 'Bookingmixin_onFinishedCoordinateImport', isActive: false})
        },

        removeClosedTaskFromRawTasks(task){
            let hasRawTask = this.rawTasks.has(task.id)
            if(!hasRawTask){
                console.error(`Kunne ikke fjerne opgave ${task.number} fra rawTasks, fordi den ikke kunne findes iblandt rawTasks`)
            } else {
                console.log(`Removing task from rawTasks id ${task.id}`)
                this.rawTasks.delete(task.id)
            }
        },

        async showHideClosedTasks(areaCodes){
            EventBus.$emit('function-activity', {functionName: 'Bookingmixin_showHideClosedTasks', isActive: true})
            console.log('showHideClosedTasks')
            this.getClosedLoading = true
            try {
                if (this.settingsBD.get("showClosed")) {
                    this.closedTasks = await this.dataGetClosedProjectTasks(new Date(this.closedSince), areaCodes)
                    console.log("Closed tasks",this.closedTasks)


                    this.closedTasks.forEach(task => this.setOrUpdateTaskInRawTasks(task))
                    // this.closedTasks.troubleTickets.forEach(ticket => this.setOrUpdateTaskInRawTasks(ticket))

                } else {
                    let rawTaskCount = this.rawTasks.size

                    this.closedTasks.forEach(task => this.removeClosedTaskFromRawTasks(task))
                    // this.closedTasks.troubleTickets.forEach(task => this.removeClosedTaskFromRawTasks(task))

                    console.log(`rawTaskCount before start: ${rawTaskCount}\nrawTaskCount after finish: ${this.rawTasks.size}`)
                }
    
                await this.bindClosedAppointments(this.settingsBD.get("showClosed"))
                await this.bookFormatBookingData(this.settingsBD.get("showMap"))
            }
            catch (error){
                console.error(error)
                swal('Fejl i hentning af lukkede opgaver', error.message, 'error')
            }
            this.getClosedLoading = false
            EventBus.$emit('function-activity', {functionName: 'Bookingmixin_showHideClosedTasks', isActive: false})
        },

        formatBookingGroup(groupKey) {
            if (!groupKey || !String(groupKey)) return 'N/A'
            if (Number(groupKey) < 6000) { //Header looks like a zipcode or areaCode
                return String(groupKey)
            }
            if (String(groupKey).match(/[a-z]/g)) { //String containing lowercase letters
                return String(groupKey)
            }
            let dateFormatted = this.formatMachineDate(groupKey)
            if (!dateFormatted || dateFormatted == 'N/A') {
                return String(groupKey)
            }
            return dateFormatted
        },

        findFirstProductDeliveryDate(productsArr) {
            if (!productsArr) return null
            if (typeof productsArr[Symbol.iterator] != 'function'){ //If productsArr is non-iterable, the loop will throw an error, so we dont bother
                console.error('findFirstProductDeliveryDate function called with invalid (non iterable) input', productsArr)
                return null
            }
            let firstExpectedDeliveryDate = null
            let filteredOrderLines = this.filterProductOrderlines(productsArr, true);
            for (let product of filteredOrderLines) {
                if (!firstExpectedDeliveryDate || product.expectedDeliveryDate < firstExpectedDeliveryDate) {
                    firstExpectedDeliveryDate = product.expectedDeliveryDate
                }
            }
            return firstExpectedDeliveryDate
        },

        filterProductOrderlines(orderLines, fallbackToUnfiltered = true){ //Expected response is an array of objects, with an 'orderLines' property which is an array
            if (!orderLines) return []
           
            // let allowedProductGroups = ['Internet', 'Hardware Wifi', 'Internet Service for Hardware', 'Wholesale - FiberBSA', 'Tilslutningsbidrag']
            let disallowedProductGroups = ['Rabatter', 'OTT', 'Internet Service'];
            let disallowedProductNames = ['Etablering', 'Rabat', 'Oprettelse'];
            let filteredOrderLines = orderLines.filter(orderLine => {
                let containsDisallowedGroup = false
                if (!orderLine.productGroup && !orderLine.productName) {
                    return false //Do not include orderLines with no prodct or no productGroups
                } 
                if (disallowedProductGroups.some(group => orderLine.productGroup && orderLine.productGroup.includes(group))){
                    containsDisallowedGroup = true
                }
                if (disallowedProductNames.some(name => orderLine.productName && orderLine.productName.includes(name))){
                    containsDisallowedGroup = true
                }
                return !containsDisallowedGroup
            })
            
            if (fallbackToUnfiltered && !filteredOrderLines.length){
                console.warn('No orderLines passed the filter, falling back to unfiltered orderLines')
                filteredOrderLines = orderLines
            }

            return filteredOrderLines
        },

        convertV1ProductsToV3Products(v1Products){
            if (!v1Products) return []
            let orderLines = []
            for (let i in v1Products) {
                let product = v1Products[i]
                for (let l in product.orderLines){
                    orderLines.push(product.orderLines[l])
                }
            }

            let v3Products = orderLines.map(product => {
                return {
                    productName: product.product.description || 'N/A',
                    productGroup: product.product.productGroups[0]?.name || null,
                    expectedDeliveryDate: product.expectedDeliveryDate || null,
                    actualDeliveryDate: product.actualDeliveryDate || null,
                    expectedCancellationDate: product.expectedCancellationDate || null,
                    actualCancellationDate: product.actualCancellationDate || null,
                    tempOrder: false
                }
            })

            return v3Products
        },

        getClusterGroup(ins) {

            const task = ins.tasks[0]

            if (!task) {
                return 'default'
            }

            let appointment = this.appointments.find(a => a.InstallationLabel == ins.label)

            switch (true) {
                case ins.label == this.activeInstallationLabel:
                    return 'active'
                case (!!task.connectionDate && appointment && this.formatMachineDate(this.readTimeWindowString(appointment.TimeWindowString).Date) == this.formatMachineDate(task.connectionDate)):
                    return 'done'
                
                case this.objExistsInArray('InstallationLabel', ins.label, this.appointments): // Check in appointment.ProjectTasks array
                    return 'draft'
                
                case this.insContainsOnlyState(ins, TaskState.PENDING):
                    return 'pending'
                
                case this.insContainsState(ins, TaskState.OPEN):
                    return 'open'
                
                default:
                    return 'default'
            }
        },

        getAllTroubleTicketsForInst(instLabel, forceFetch = false){
            // if load trouble tickets (loadTickets)
            // if forcefetch get all tickets
            // get full tickets

            console.log(instLabel, forceFetch)
        },

        uniqueBookingGroups(installations, groupField, returnAsKeys) {
            let uniqueGroups = []
            for (let ins of installations) {
                let groupKey
                if (ins.appointments?.length && groupField == 'AppointmentDate'){
                    for (let app of ins.appointments) {
                        groupKey = this.formatMachineDate(app.Date)
                        if (!groupKey) groupKey = 'N/A'
                        if (!uniqueGroups.includes(groupKey)){
                            uniqueGroups.push(this.formatBookingGroup(groupKey))
                        }
                    }
                } 
                else if (ins.appointment?.Date && groupField == 'AppointmentDate') {
                    groupKey = this.formatMachineDate(ins.appointment.Date)
                } 
                else if (groupField == 'tags'){
                    groupKey = 'Uden mærkat';
                    if (ins.updates?.Tags?.length) {
                        groupKey = ins.updates.Tags[0]
                    }
                }
                else if (ins.tasks && ins.tasks[0]) {
                    if (groupField.indexOf('.') == -1) {
                        groupKey = ins.tasks[0][groupField]
                    } else {
                        groupKey = this.resolveObjPath(groupField, ins.tasks[0])
                    }
                }
                if (!groupKey) groupKey = 'N/A'
                if (!uniqueGroups.includes(groupKey)){
                    uniqueGroups.push(this.formatBookingGroup(groupKey))
                }
            }

            // console.log(uniqueGroups)
            if (returnAsKeys) {
                //convert array of strings to object with strings as property keys and empty arrays as values
                return uniqueGroups.reduce((v,i) => (v[i] = [], v), {})
            }
            return uniqueGroups
        },

        combineUniqueBookingGroups(group0, group1){
            let keys = Object.keys(group0)
            let groupsToBeDeleted = []
            for (let key in group1){
                if (keys.includes(key)){
                    console.log("Same key found",key)
                    for (let i in group1[key]){
                        group0[key].push(group1[key][i])
                    }
                    groupsToBeDeleted.push(key)
                }
            }

            for (let i in groupsToBeDeleted){
                delete group1[groupsToBeDeleted[i]]
            }
        },

        bookingGetInitials(booking, noAppointment = false) {
            if (!booking) return null
            if (noAppointment){
                return booking.tasks[0]?.assignee
            } else {
                return booking.appointment?.Worker?.Email?.split('@')[0].toLowerCase() || booking.appointment?.WorkerInitials?.toLowerCase()
            }
        },

        bookingGetTimeWindow(booking, noAppointment = false) {
            if (!booking) return null
            if (noAppointment){
                return null
            } else {
                if (!booking.appointment) return null
                return booking.appointment.TimeWindowString
            }
        },

        bookingGetZipCode(booking, noAppointment = false) {
            if (booking?.appointment?.AppointmentType == "Custom") return 0
            if (noAppointment){
                return this.getConfigurationInstallation(booking)?.address?.zipcode
            } else {
                if (booking?.appointment?.AddressLong == 'null' || !booking?.appointment?.AddressLong) return 0

                let decontructedAddress = booking.appointment.AddressLong.split(',')
                if (decontructedAddress.length < 2) return 0
                return decontructedAddress[1].replace(/\D/g,'')
            }
        },

        bookingGetAddress(booking, noAppointment = false) {
            if (noAppointment){
                return this.formatAddress(this.getConfigurationInstallation(booking)?.address).split(',')[0]
            } else {
                if (booking?.appointment?.AppointmentType == "Custom" || (typeof(booking?.appointment?.AddressLong) == "undefined")) return 0
                return booking?.appointment?.AddressLong.split(',')[0]
            }

        },

        bookingGetDueDate(booking, noAppointment = false){
            if (noAppointment){
                if (!booking?.troubleTicketCount) return null
                return booking.tasks[0]?.dueDate
            }
            return null
        },

        bookingGetInstallationFirstSeen(booking, noAppointment = false){
            if (noAppointment){
                return booking?.installationFirstSeen
            }
            return null
        },

        /**
         * Function that returns true if the booking should be marked as a draft
         * @param {Object} booking installation Object containing property appointment
         * @returns {Boolean} weather or not the booking is a draft
         */
        bookingIsDraft(booking){
            if (!booking || !booking.appointment) return false //If there is no booking, it cannot be a draft
            if (!booking.appointment.Confirmed) return true //If the appointment is specifically not confirmed, it must be a draft

            const timeWindowStringArr = booking.appointment.TimeWindowString.split(';')
            if (timeWindowStringArr.length != 3) return false //timeWindowString seems invalid
            let plannedStartToMatch;
            let plannedEndToMatch; 

            plannedStartToMatch = `${this.formatMachineDate(booking.appointment.Date, '-')} ${timeWindowStringArr[1]}:00`
            plannedEndToMatch = `${this.formatMachineDate(booking.appointment.Date, '-')} ${timeWindowStringArr[2]}:00`
            
            const primaryTaskCode = AppointmentType.AppointmentTasks[booking.appointment.AppointmentType].primary.taskCode
            const primaryTask = booking.tasks.find((task) => TaskCode.taskHasCode(task, primaryTaskCode))
            if (!primaryTask) return false
            // console.log(primaryTask.plannedStart, plannedStartToMatch, primaryTask.plannedStart == plannedStartToMatch)
            // console.log(primaryTask.plannedEnd, plannedEndToMatch, primaryTask.plannedEnd == plannedEndToMatch)
            return (
                plannedStartToMatch != primaryTask.plannedStart ||
                plannedEndToMatch != primaryTask.plannedEnd
            )
        },

        appointmentIsDraft(inst){
            if (!inst || !inst.appointment) return false
            if (!inst.appointment.Confirmed) return true
            return false
        },

        headerFromGroupKey(groupKey, settings) {
            if ((settings.get('sortUnbookedPTBy') == 'tags' || settings.get('sortUnbookedTTBy') == 'tags') && this.project.Tags){
                let tagKeys = []
                for (let i in this.project.Tags){
                    tagKeys.push(this.project.Tags[i].value)
                }
                if (tagKeys.includes(groupKey)){
                    groupKey = `Mærkat: ${this.project.Tags.find(tag => tag.value == groupKey).text}`
                    return groupKey;
                }
            }

            if (settings.get('sortUnbookedPTBy') == 'TaskFirstSeen' || settings.get('sortUnbookedTTBy') == 'TaskFirstSeen'){
                if (groupKey == 'N/A') return 'Uden dato (Før implementering)'
            }

            if (Number(groupKey) < 6000 && Number(groupKey) > 4999) { //Is funen zipcode
                return `${String(groupKey)} ${this.zipCodeName(groupKey) || ''}`
            }
            if (typeof groupKey == 'string' && groupKey.match(/[a-z-]|[A-Z]{3,}/g)) { //Either normal words, camelCase string, or string containing '-'
                if (groupKey.includes(' ') || groupKey.includes('-')) return groupKey
                return this.camelCaseToSentence(groupKey)
            }

            if (groupKey == '9999/12/31' && this.getProjectSetting(this.project,"sortOverrideProductDeliveryDate")){
                let groupKeyHeader = this.toUserFriendlyDate(groupKey, true, settings.get('showWeekNums'))
                groupKeyHeader += ' (HASTER!)'
                return groupKeyHeader
            }

            return this.toUserFriendlyDate(groupKey, true, settings.get('showWeekNums'))
        },

        async saveUpdateToInstallation(user, installation, selectedWorker, selectedWorkers, route, flagAppointment, addToCancellationList, isHouseAssociation, selectedTags, slaBreached, slaBreachReason) {
            let userObj = {
                displayName: user.displayName || user.Name,
                email: user.email || user.Email,
            }

            let projectTaskIds = []
            installation.tasks.forEach((task) => {
                projectTaskIds.push(task.id)
            })

            let tmpWorker = selectedWorker
            if (route == 'TtProjectBooking'){
                let workerIndex = this.workerOptions.findIndex((w) => {return w.value == selectedWorker})
                tmpWorker = this.workerOptions[workerIndex].text
            }

            if (installation.updates && installation.updates.id){
                let newState = 'active'
                if ((tmpWorker == null || tmpWorker == 'Ingen') && 
                    flagAppointment == false && 
                    addToCancellationList == false && 
                    isHouseAssociation == false && 
                    selectedTags.length == 0
                ){
                    newState = 'passive'
                }

                let document = {
                    State: 'active',
                    BookingState: newState,
                    Updated: new Date(),
                    UpdatedBy: userObj,
                    Flag: flagAppointment,
                    IsHouseAssociation: isHouseAssociation,
                    IsOnCancellationList: addToCancellationList,
                    Worker: tmpWorker,
                    Workers: selectedWorkers,
                    Tags: selectedTags,
                    InstallationLabel: this.getConfigurationLabel(installation.tasks[0]),
                    ProjectTaskIds: projectTaskIds,
                    SLABreached: slaBreached,
                    SLABreachReason: slaBreachReason
                }

                if (!installation.updates.IsOnCancellationList){
                    document.CancellationListTimestamp = new Date()
                }

                await db.collection('UpdatesToInstallations').doc(
                    installation.updates.id).update(document) // Update document in firestore

            } else {
                let document = {
                    State: 'active',
                    BookingState: 'active',
                    Updated: new Date(),
                    UpdatedBy: userObj,
                    Created: new Date(),
                    CreatedBy: userObj,
                    Flag: flagAppointment,
                    IsHouseAssociation: isHouseAssociation,
                    IsOnCancellationList: addToCancellationList,
                    Tags: selectedTags,
                    CancellationListTimestamp: new Date(),
                    Worker: tmpWorker,
                    Workers: selectedWorkers,
                    InstallationLabel: this.getConfigurationLabel(installation.tasks[0]),
                    ProjectTaskIds: projectTaskIds,
                    SlaBreached: slaBreached,
                    SlaBreachReason: slaBreachReason
                }

                console.log("Doc to FireBase",document)
                let docRef = db.collection('UpdatesToInstallations').doc() // Create document and get auto generated ID
                await docRef.set(document) // Save document to firestore
            }
        },

        async updateTagsOnInstallation(user, installation, selectedTags){
            
            if (Object.keys(installation.appointments).length){
                let appointmentId = Object.keys(installation.appointments)[0]
                
                await this.dataAddOrUpdateAppointment(appointmentId, {Tags: selectedTags})
                return;
            }
            
            let userObj = {
                displayName: user.displayName,
                email: user.email,
            }

            if (installation.updates && installation.updates.id){

                let newState = 'active'
                if (selectedTags.length == 0){
                    newState = 'passive'
                }
                let document = {
                    State: 'active',
                    BookingState: newState,
                    Updated: new Date(),
                    UpdatedBy: userObj,
                    Tags: selectedTags
                }

                await db.collection('UpdatesToInstallations').doc(installation.updates.id).update(document) // Update document in firestore
                return;

            } 
            
            let document = {
                State: 'active',
                BookingState: 'active',
                Updated: new Date(),
                UpdatedBy: userObj,
                Created: new Date(),
                CreatedBy: userObj,
                Tags: selectedTags,
                CancellationListTimestamp: new Date(),
                InstallationLabel: this.getConfigurationLabel(installation.tasks[0]),
            }

            console.log("Doc to FireBase",document)
            let docRef = db.collection('UpdatesToInstallations').doc() // Create document and get auto generated ID
            await docRef.set(document) // Save document to firestore
            return;
        }

    },

    watch: {
        'appointments': 'onAppointmentsMutated',
        'tasks': 'updateInstallations',
    }

}
